module.exports = __webpack_public_path__ + "static/sider-logos-9944147c91158ef850704cb27707af2d.png";